import VideoPlayer from './VideoPlayer';

export default VideoPlayer;
export * from './VideoPlayer';
